import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../../common';
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';
import { DpsCommonModule } from '../dataprotection-common/dataprotection-common.module';
import { ActivityLogModule } from '../../../components/activity-log/activity-log.module';
import { ReplicatedVdcModule } from './replicated-vdc/replicated-vdc.module';

import DataProtectionVCD from './dataprotection-vcd.component';
import { DeletedVapps } from './deleted-vapps/deleted-vapps.component';
import { Vapps } from './vapps/vapps.component';
import { ApplyPolicy } from './apply-policy/apply-policy.component';
import { DeletePolicy } from './delete-policy/delete-policy.component';
import { AdhocBackup } from './adhoc-backup/adhoc-backup.component';
import { ConfigureEmail } from './configure-email/configure-email.component';
import { RestorePoints } from './restore-points/restore-points.component';
import { DeleteRestore } from './delete-restore/delete-restore.component';
import { RefreshRestore } from './refresh-restore/refresh-restore.component';
import { UpdateRestore } from './update-restore/update-restore.component';
import { InPlaceRestore } from './in-place-restore/in-place-restore.component';
import { OutOfPlaceRestore } from './out-of-place-restore/out-of-place-restore.component';
import { SetReplicationSite } from './replicated-vdc/set-replication-destination.component';
import { ReplicatedApplyPolicy } from './replicated-vdc/apply-policy.component';
import { ReplicatedDeletePolicy } from './replicated-vdc/delete-policy.component';
import { ReplicateVapp } from './replicated-vdc/replicate-vapp.component';
import { StorageTrendGraph } from './dashboard/storage-trend-graph.component'
import { DPSDashboard } from './dashboard/dps-dashboard.component';
import { DpsService } from './dashboard/dps-service.service';
import { VdcCard } from './vdc-card/vdc-card.component';
import { VappCard } from './vapp-card/vapp-card.component';

@NgModule({
    declarations: [
        DataProtectionVCD,
        Vapps,
        DeletedVapps,
        ApplyPolicy,
        DeletePolicy,
        AdhocBackup,
        ConfigureEmail,
        RestorePoints,
        DeleteRestore,
        RefreshRestore,
        UpdateRestore,
        InPlaceRestore,
        OutOfPlaceRestore,
        SetReplicationSite,
        ReplicatedApplyPolicy,
        ReplicatedDeletePolicy,
        ReplicateVapp,
        DPSDashboard,
        StorageTrendGraph,
        VdcCard,
        VappCard
    ],
    imports: [
        BrowserModule,
        FormsModule,
        VcaCommonModule,
        ActivityLogModule,
        ReplicatedVdcModule,
        TranslateModule,
        ClarityModule.forRoot(),
        Ng2DatetimePickerModule,
        DpsCommonModule
    ],
    providers: [
        DpsService
    ],
    exports: [
        DataProtectionVCD,
        Vapps,
        DeletedVapps,
        ApplyPolicy,
        DeletePolicy,
        AdhocBackup,
        ConfigureEmail,
        RestorePoints,
        DeleteRestore,
        RefreshRestore,
        UpdateRestore,
        InPlaceRestore,
        OutOfPlaceRestore,
        SetReplicationSite,
        ReplicatedApplyPolicy,
        ReplicatedDeletePolicy,
        ReplicateVapp,
        DPSDashboard,
        StorageTrendGraph,
        VdcCard,
        VappCard
    ]

})
export class DpsVcdModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/dataprotection-vcd.module.ts